import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import SelectInput from "../components/inputs/selectInput";
import * as app from "../../../app/redux/appRedux";
import * as reportsRedux from "../../reports/redux/reportsRedux";

class InquiryTypeFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "",
            options: [
                { value: "LVT In-House", label: "LVT In-House" },
                { value: "In-house", label: "In-house" },
                { value: "Coaching", label: "Coaching" },
                { value: "E-Learning", label: "E-Learning" },
                { value: "Consulting", label: "Consulting" },
                { value: "Learning Journey", label: "Learning Journey" },
            ],
        };
        this.switchCheckbox = this.switchCheckbox.bind(this);
    }

    onChange = (selectedOption) => {
        this.props.selectInquiryType(selectedOption);
        this.setState({ type: selectedOption });
    };

    onInputChange = (str, { action }) => {
        if (action === "set-value") return false;
        this.setState({ inputValue: str });
    };

    switchCheckbox() {
        this.props.setIsSelectAllInquiryTypes(!this.props.isSelectAllInquiryTypes);
    }

    render() {
        return (
            <>
                {this.props.isMultiSelect ? (
                    <SelectInput
                        object={{
                            //  fn: this.getUsers().fn,
                            //  unitId: this.getUsers().unitId,
                            name: "  Inquiry Type",
                            data: {
                                options: this.state.options,
                            },
                            multi: true,
                            allSelectable: true,
                            value: this.props.inquiryType,
                        }}
                        onChange={this.onChange}
                        onInputChange={this.onInputChange}
                        infinite={false}
                    />
                ) : (
                    <Select
                        className="selectInputNewFilter_single"
                        classNamePrefix="selectInputNewFilter"
                        options={this.state.options}
                        defaultValue={this.props.inquiryType}
                        value={this.props.inquiryType}
                        onChange={this.onChange}
                        closeMenuOnSelect={true}
                        isMulti={this.props.isMultiSelect}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        inquiryType: state.reports.selectedInquiryType,
        isSelectAllInquiryTypes: state.reports.isSelectAllInquiryTypes,
    };
};

const mapDispatchToProps = {
    ...reportsRedux.actions,
    ...app.actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryTypeFilter);
